import type {
    IInternationalVisitsFilterDto,
    ILeadsSearchLeadsFiltersDto,
} from "app/pages/sales-intelligence/domain/leads/types/filter-values";
import { FilterPanelBaseFilter } from "app/pages/sales-intelligence/modules/advanced-search-filtering/models/BaseFilter";
import type { IFilterPanelBaseFilterDeps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filters";
import type { FilterValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/misc";
import { calculateObjectValueDelta } from "app/pages/sales-intelligence/modules/advanced-search-filtering/utils/calculateValueDeltaUtils";
import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";

import type { InternationalVisitsFilterOptions } from "./types";

export default class FindInternationalVisitsFilter extends FilterPanelBaseFilter<
    IInternationalVisitsFilterDto,
    InternationalVisitsFilterOptions,
    IInternationalVisitsFilterDto,
    ILeadsSearchLeadsFiltersDto
> {
    constructor(deps: IFilterPanelBaseFilterDeps<IInternationalVisitsFilterDto, InternationalVisitsFilterOptions>) {
        super(deps);
    }

    isFilterDirty(currentValue: IInternationalVisitsFilterDto | undefined): boolean {
        return JSON.stringify(this.initialDtoValue ?? {}) !== JSON.stringify(currentValue ?? {});
    }

    affectValue(
        filtersValue: ILeadsSearchLeadsFiltersDto,
        value: IInternationalVisitsFilterDto | undefined,
    ): IInternationalVisitsFilterDto | undefined {
        const { countries } = filtersValue;

        if (!countries?.length || (countries.length === 1 && countries[0] === WORLDWIDE_COUNTRY_ID)) {
            return value;
        }

        return undefined;
    }

    calculateValueDelta(
        previousValue: IInternationalVisitsFilterDto | undefined,
        newValue: IInternationalVisitsFilterDto | undefined,
    ): FilterValueDelta<IInternationalVisitsFilterDto> {
        return calculateObjectValueDelta<Partial<IInternationalVisitsFilterDto>>(previousValue, newValue);
    }
}
